<template>
    <div class="body">
        <div class="banner">
            <div class="banner_name">
                <img src="@/assets/img/name2.png" alt="">
            </div>
            <div class="small_name">兔年新品 . 官方正品 . 优惠套餐</div>
        </div>
        <div class="activity">
            <div class="activity_flex">
                <div class="activity_left">200G</div>
                <div class="activity_right">
                    <div class="activ_month">月享</div>
                    <div class="activ_month1">高速全国通用流量</div>
                </div>
            </div>
            <div class="month">19<span>元/月</span></div>
        </div>
     
        <div class="package1">
            <div class="package_name">原套餐39元包200G</div>
            <div class="package_content"><span>参与冲100元得480元活动</span>，分24张优惠券。每次订购套餐可直接抵扣20元！折合每月19元/200G（后期可持续参加活动）。此卡六个月后，方能开通语音短信功能</div>
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="disaShow('100')">参加19元套餐活动</van-button>
        </div>

        
        <div class="package">
            <div class="package_name">至尊包年套餐-月500G</div>
            <div class="package_content"><span>参与充值388元年包套餐</span>，套餐直接到账12个月。每个月可享受500G高速流量，折合每月32元/500G（后期可持续参加活动）。此卡六个月后，方能开通语音短信功能</div>
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="disaShow('388')">购买包年套餐</van-button>
        </div>
       


        <!-- <div class="btn" @click="isDialogShow=true"></div> -->
        <!--显示活动弹窗-->
        <div class="v-dialog" v-if="isDialogShow">
            <div class="v-dialog-bg"></div>
            <div class="v-dialog-content" :class="{'v-dialog-content1': amountNum === 100}">
                <div class="input">{{input}}</div>
                <div class="sumbit_btn" @click="sureToRecharge()"></div>
                <div class="v-dialog-close">
                    <img src="@/assets/dzp/dialog_close.png" alt="" @click="isDialogShow=false" />
                </div>
            </div>
        </div>
        <!-- 修改密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"
            style="z-index: 2000; min-height: 25%; min-width: 80%;"
            v-show="showPasswordPanel"
            :style="{top:passwordPanelTop+'%'}"
        >

        <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>

        <!-- 密码输入框 -->
        <p>设置开户支付密码：</p>
        <van-password-input
            :value="password"
            :focused="passwordKeyboard"
            @focus="passwordOnfocus()"
        />

        <!-- 再次确认密码输入框 -->
        <p>再次确认开户密码：</p>
        <van-password-input
            :value="confirmPassword"
            :focused="confirmPasswordKeyboard"
            @focus="confirmPasswordOnfocus()"
        />
        <div class="confirmChangePassword">
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定
            </van-button>
        </div>

        </div>

        <!-- 数字键盘 -->
        <van-number-keyboard
            :z-index="2015"
            :show="passwordKeyboard"

            @input="passwordOnInput"
            @delete="passwordOnDelete"
            @blur="passwordKeyboard = false"
        />

        <van-number-keyboard
            :z-index="2015"
            :show="confirmPasswordKeyboard"

            @input="confirmPasswordOnInput"
            @delete="confirmPasswordOnDelete"
            @blur="confirmPasswordKeyboard = false"
        />
        <!-- 数字键盘 end -->
        <!-- 修改密码框 end  -->
    </div>
</template>
<script>
import {Dialog,Toast} from 'vant';
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return{
             newHome:this.$store.state.newHome,
            newHomes: localStorage.getItem("newHome"),
            input:this.$store.state.recordLoginText,
            isDialogShow:false,
            //设置密码
            password: '',
            confirmPassword: "",
            alreadySetUp: false,
            showPasswordPanel: false,
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,
            amountNum:0,

            //当前余额套餐
            currentItem: 0,
            price: 0,
            giftBalance: 0,

            //自定义金额
            popup: false,

            //自定义键盘
            showKeyboard: false,
            definedPrice: '',

            type: '',
            indexActive: '',
        }
    },
    methods:{
        /***   修改密码     ***/
        passwordOnfocus() {
            this.passwordKeyboard = true;
            this.confirmPasswordKeyboard = false;
            this.passwordPanelTop = 30;
        },
        passwordOnDelete() {
            this.password = this.password.slice(0, this.password.length - 1);
        },

        passwordOnInput(key) {
            this.password = (this.password + key).slice(0, 6);
        },


        confirmPasswordOnfocus() {
            this.passwordKeyboard = false;
            this.confirmPasswordKeyboard = true;
            this.passwordPanelTop = 30;
        },
        confirmPasswordOnDelete() {
            this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
        },

        confirmPasswordOnInput(key) {
            this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
        },


        cancelChangePassword() {
            this.password = '';
            this.confirmPassword = '';
            this.passwordPanelTop = 50;
            this.showPasswordPanel = false;
        },

        checkPassword() {
            if (this.password.length < 6) {
                Dialog.alert({message: "请设置六位支付密码"});
                return false;
            }

            if (this.password != this.confirmPassword) {
                Dialog.alert({message: "两次输入的新密码不一致"});
                return false;
            }
            return true;
        },


        /***   修改密码  end   ***/
        sumbit(){
            this.showPasswordPanel = true;
        },
         onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', param,
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        if(this.newHome==1||this.newHomes==1){
                                 _this.$router.push({
                        path: '/newUser/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }else{
                             _this.$router.push({
                        path: '/user/home',
                        query: {
                        iccid: _this.$store.state.iccid
                        }
                    }).catch(() => {

                    });
                        }
                    }
                }
            );
        },
        disaShow(amount){
            this.amountNum = amount * 1
            this.isDialogShow = true 
        },
        sureToRecharge(){
            var params = {         
                iccid:this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'), 
                amount: this.amountNum * 100, //固定值         
                giftBalance: 0, //固定值 	   
                yucun: 1, //固定值
                payType: 20,// 固定微信支付         
                         
            }
            wxRequest("order/user/create/priceOrder", params, "post").then(res => {
                if (res.data.code == 200) {
                    if (params.payType == 50) {//乐刷
                        window.location.href = res.data.data.jspay_url;
                    } else if (params.payType == 20) {//微信第三方
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                       
                    } else if (params == 60) { //汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === 'succeeded') {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({title: '提示', message: res.result_message});
                            })
                        }
                    }
                } else {
                    Dialog.alert({message: res.data.message});
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.body{
    // background: url('../../assets/dzp/xy.jpg')no-repeat center;
    
    width:100%;
    height:100vh;
    padding-bottom:40px;
    position: relative;
    .banner{
        background: url('../../assets/img/bg.png')no-repeat center;
        background-size: 100% 100%;
        height:312px;
        text-align: center;
        .banner_name{
            padding-top:60px;
        }
        .small_name{
            margin-top:14px;
            color:#fff;
            font-size:16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }
    }
    .activity{
        position: absolute;
        width:94%;
        top:160px;
        left: 0;
        right: 0;
        bottom: 0;
        margin:0 auto;
        // background: url('../../assets/img/bg1.png') no-repeat center;
        // background-size: 100% 100%;
        height:150px;
        .activity_flex{
            display: flex;
            .activity_left{
                padding:18px 0 14px 0;
                font-size: 48px;
                color: #F74D12;
                font-family: HarmonyOS_Sans_SC_Black;
                font-weight:600;
                padding-left: 28px;
            }
            .activity_right{
                padding:18px 0;
                padding-left:9px;
                .activ_month{
                    color:#fff;
                    font-size:14px;
                    background: #E2A542;
                    border-radius:4px;
                    width:38px;
                    height:22px;
                    text-align: center;
                    line-height:22px;
                }
                .activ_month1{
                    font-size:14px ;
                    color: #E2A542;
                    padding-top:8px;
                }
            }
        }
        .month{
            padding-left:36px;
            font-size:30px;
            color: #E2A542;
            font-family: HarmonyOS_Sans_SC_Bold;
            font-weight:600;
            span{
                font-size:17px;
                font-weight: normal;
            }
        }
    }
    .package,.package1{
        margin:0 auto;
        margin-top:50px;
        width:86%;
        padding:19px 15px 16px;
        border-radius: 16px;
        text-align: center;
        border:1px solid #F9EBCE;
        .package_name{
            color: #171717;
            font-size:22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            margin-bottom:8px;
        }
        .package_content{
            font-size:15px;
            color: #797979;
            margin-top:8px;
            line-height: 24px;
            margin-bottom:16px;
            span{
                color: #F86321;
            }
        }
        .confirmChangePasswordBtn{
            background: #F86C2E;
            width:90%;
            margin:0 auto;
            color:#fff;
            font-size:22px;
            font-family: HarmonyOS_Sans_SC_Bold;
            font-weight:600;
            border: 1px solid #F86C2E;
            border-radius:23px;
            height:46px;
            &::after{
                border:none ;
            }
        }
    }
    .package1{
        margin-top:13px;
    }
    .btn{
        width: 325px;
        position: fixed;
        bottom: 20px;
        left: 0px;
        right: 0px;
        margin: auto;
        height: 64px;
        background: url('../../assets/dzp/6fdec6ce.png')no-repeat center;
        background-size: 100% 100%;
    }
    .v-dialog{
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        bottom: 0;
        left:0;
        right:0;
        margin:auto;
        .v-dialog-bg{
            position: fixed;
            background: rgba(0,0,0, .7);
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width:100%;
            height:100%;
        }
        .v-dialog-close{
            width:22px;
            height:22px;
            // margin:0 auto;
            // margin-top:20px;
            position: fixed;
            top:0;
            bottom:-300px;
            left:0;
            right:0;
            margin:auto;
            img{
                height:100%;
                cursor: pointer;
            }
        }
        .v-dialog-content{
            position: fixed;
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width: 275px;
            height: 210px;
            background: url('../../assets/dzp/388.png') no-repeat center;
            background-size:100% 100%;
            .input{
                background: rgb(255, 255, 255);
                width: 200px;
                height: 40px;
                margin: auto;
                margin-bottom: 10px;
                border-radius: 12px;
                text-align: center;
                line-height: 40px;
                font-size: 25px;
                color: rgb(177, 54, 0);
                position: absolute;
                bottom:54px;
                display: flex;
                left:0;
                right:0;
                justify-content: center;
                align-items: center;
            }
            .sumbit_btn{
                width: 175px;
                height: 46px;
                position: absolute;
                bottom:8px;
                display: flex;
                left:0;
                margin: auto;
                right:0;
                background: url('../../assets/dzp/a2.png') no-repeat center;
                background-size:100% 100%;
            }
        }
        .v-dialog-content1{
            background: url('../../assets/dzp/100.jpg') no-repeat center;
            background-size:100% 100%;
        }
    }
}
.changePasswordPanel-cardSetUp{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
</style>